module.exports = require("./kkj.d.ts");